import {
  FaCalendarAlt,
  FaCheckCircle,
  FaRegFlag,
  FaHourglassStart,
  FaHourglassEnd,
} from "react-icons/fa";
import { MdEditSquare } from "react-icons/md";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import Wrapper from "../../assets/wrappers/Job";
import { IoIosTime } from "react-icons/io";
import CampaignInfo from "./CampaignInfo";
import day from "dayjs";
import PropTypes from "prop-types";
import styled from "styled-components";
import { customFetch } from "../../utils/custom-fetch";
import { toast } from "react-toastify";

const CampaignThumbnail = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 8px;
`;
const Campaign = ({
  _id,
  name,
  startDate,
  endDate,
  advertiser,
  status,
  media,
  displayHours,
}) => {
  const handleDeleteCampaign = async (campaignId) => {
    if (window.confirm("האם אתה בטוח שאתה רוצה למחוק את הקמפיין? כל תזמוני הקמפיינים הקשורים ימחקו.")) {
      try {
        const response = await customFetch.delete(`/campaigns/${campaignId}`);
        toast.success("הקמפיין נמחק בהצלחה");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error("Error deleting the campaign:", error);
        alert("שגיאה במחיקת הקמפיין");
      }
    }
  };

  const handleActiveCampaign = async (campaignId) => {
    if (window.confirm("האם אתה בטוח שאתה רוצה להפעיל את הקמפיין?")) {
      try {
        const response = await customFetch.patch(`/campaigns/${campaignId}`, { status: "פעיל" });
        toast.success("הקמפיין הופעל בהצלחה");
      } catch (error) {
        console.error("Error activating the campaign:", error);
        alert("שגיאה בהפעלת הקמפיין");
      }
    }
  };
  const advertiserName = advertiser?.name || "Unknown Advertiser"; 
  const formattedStartDate = day(startDate).format("DD/MM/YYYY");
  const formattedEndDate = day(endDate).format("DD/MM/YYYY");
  const start = displayHours?.start || "Unknown Start Time";
  const end = displayHours?.end || "Unknown End Time";
  const campaignImage = media?.[0]?.url || "";
  const isVideo = media?.[0]?.mediaType === "video";
  return (
    <Wrapper>
      <header>
        <div>
          {isVideo ? (
            <img
              style={{ width: "80px" }}
              src="https://res.cloudinary.com/dlhfcdscf/image/upload/v1734522806/public/video_a7ri7d.png"
            />
          ) : (
            <CampaignThumbnail src={campaignImage} alt={`${name} Thumbnail`} />
          )}
        </div>
        <div className="info">
          <h5>{name}</h5>
          <p>{advertiserName}</p>
        </div>
      </header>
      <div className="content">
        <div className="content-center">
          <CampaignInfo
            icon={<FaHourglassStart />}
            text={`${formattedStartDate}`}
          />
          <CampaignInfo
            icon={<FaHourglassEnd />}
            text={`${formattedEndDate}`}
          />
          <CampaignInfo icon={<IoIosTime />} text={`${end} - ${start}`} />

          <CampaignInfo icon={<FaRegFlag />} text={status} />
        </div>
        <>
          <div className="content-center">
            <Link to={`../advertiser-request/${_id}`} className="btn edit-btn">
              <MdEditSquare style={{ marginLeft: "20px" }} />
              עריכת הקמפיין
            </Link>
            <Link
              className="btn edit-btn" style={{ backgroundColor: "red" }}
              onClick={() => handleDeleteCampaign(_id)}
            >
              <RiDeleteBin5Fill style={{ marginLeft: "20px" }} />
              מחיקת הקמפיין
            </Link>
            { status !== "פעיל" && (
              <Link
              className="btn edit-btn" style={{ backgroundColor: "green" }}
              onClick={() => handleActiveCampaign(_id)}
            >
              <FaCheckCircle style={{ marginLeft: "20px" }} />
              הפוך לפעיל
            </Link>
            )}

          </div>
        </>
      </div>
    </Wrapper>
  );
};

Campaign.propTypes = {
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  advertiser: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
};

export default Campaign;
